"use strict";

(() => {
  const fv = document.querySelector(".p-top-fv");
  const title = fv ? fv.querySelector(".p-top-fv__title") : null;
  const bus = fv ? fv.querySelector(".p-top-fv__deco.-deco--bus") : null;

  const LINE_LAYOUT = {
    desktop: { width: 3840, height: 1848, anchorX: 0.67, anchorY: 0.887 },
    mobile: { width: 780, height: 1200, anchorX: 0.2, anchorY: 0.728 },
  };

  const getLineLayout = () => {
    return window.matchMedia("(max-width: 767px)").matches
      ? LINE_LAYOUT.mobile
      : LINE_LAYOUT.desktop;
  };

  const getCoverPoint = (containerW, containerH, imgW, imgH, nx, ny) => {
    const scale = Math.max(containerW / imgW, containerH / imgH);
    const renderedW = imgW * scale;
    const renderedH = imgH * scale;
    const offsetX = (containerW - renderedW) / 2;
    const offsetY = (containerH - renderedH) / 2;

    return {
      x: offsetX + nx * renderedW,
      y: offsetY + ny * renderedH,
    };
  };

  if (fv && title) {
    const units = title.querySelectorAll(".p-top-fv__titleUnit");
    const subTitle = fv.querySelector(".p-top-fv__subTitle");
    const line = fv.querySelector(".p-top-fv__layer.-layer--line");
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const resetAnimatedText = (el) => {
      if (!el) {
        return;
      }

      el.style.animation = "none";
      el.style.opacity = "0";
      el.style.filter = "none";
      el.style.transform = "none";
    };

    const clearAnimatedText = (el) => {
      if (!el) {
        return;
      }

      el.style.animation = "";
      el.style.opacity = "";
      el.style.filter = "";
      el.style.transform = "";
    };

    const layoutBus = () => {
      if (!bus) {
        return;
      }

      const fvRect = fv.getBoundingClientRect();
      const lineLayout = getLineLayout();
      const anchor = getCoverPoint(
        fvRect.width,
        fvRect.height,
        lineLayout.width,
        lineLayout.height,
        lineLayout.anchorX,
        lineLayout.anchorY
      );

      fv.style.setProperty("--fv-bus-x", `${anchor.x}px`);
      fv.style.setProperty("--fv-bus-y", `${anchor.y}px`);
    };

    // 連続グラデーション用に各チャンクへ背景サイズ・オフセットを配分
    const layoutTitle = () => {
      const titleRect = title.getBoundingClientRect();
      title.style.setProperty("--fv-bg-w", `${titleRect.width}px`);
      title.style.setProperty("--fv-bg-h", `${titleRect.height}px`);

      units.forEach((unit) => {
        const unitRect = unit.getBoundingClientRect();
        unit.style.setProperty("--fv-x", `${-(unitRect.left - titleRect.left)}px`);
        unit.style.setProperty("--fv-y", `${-(unitRect.top - titleRect.top)}px`);
      });
    };

    const layout = () => {
      layoutTitle();
      layoutBus();
    };

    const resetFvAnimation = () => {
      fv.classList.remove("is-fvAnimate");

      units.forEach((unit) => {
        resetAnimatedText(unit);
      });

      resetAnimatedText(subTitle);

      if (bus) {
        bus.style.animation = "none";
        bus.style.transform = "none";
      }

      if (line) {
        line.style.animation = "none";
        line.style.clipPath = "inset(0 100% 0 0)";
      }

      void fv.offsetWidth;

      units.forEach((unit) => {
        clearAnimatedText(unit);
      });

      clearAnimatedText(subTitle);

      if (bus) {
        bus.style.animation = "";
        bus.style.transform = "";
      }

      if (line) {
        line.style.animation = "";
        line.style.clipPath = "";
      }
    };

    const runFv = () => {
      if (reduce) {
        layout();
        fv.classList.add("is-fvAnimate");
        return;
      }

      resetFvAnimation();
      layout();

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          fv.classList.add("is-fvAnimate");
        });
      });
    };

    const startFv = () => {
      runFv();
    };

    layoutBus();

    if (document.querySelector("[data-loading]")) {
      document.addEventListener("theme:fvStart", startFv, { once: true });
    } else {
      startFv();
    }

    // bfcache 復帰時
    window.addEventListener("pageshow", (event) => {
      if (event.persisted) {
        startFv();
      }
    });

    // バスは即追従、タイトルグラデーションのみデバウンス
    let titleLayoutTimer = null;
    const scheduleTitleLayout = () => {
      if (titleLayoutTimer) {
        window.clearTimeout(titleLayoutTimer);
      }
      titleLayoutTimer = window.setTimeout(layoutTitle, 200);
    };

    const syncBusOnResize = () => {
      layoutBus();
      scheduleTitleLayout();
    };

    if (typeof ResizeObserver !== "undefined") {
      const fvObserver = new ResizeObserver(() => {
        syncBusOnResize();
      });
      fvObserver.observe(fv);
    } else {
      window.addEventListener("resize", syncBusOnResize);
    }

    const lineMql = window.matchMedia("(max-width: 767px)");
    lineMql.addEventListener("change", layoutBus);
  }
})();
